var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3361 21.6666C2.60277 21.6666 1.97499 21.4055 1.45277 20.8833C0.930545 20.3611 0.669434 19.7333 0.669434 19V2.99998C0.669434 2.26665 0.930545 1.63887 1.45277 1.11665C1.97499 0.594424 2.60277 0.333313 3.3361 0.333313H24.6694C25.4028 0.333313 26.0305 0.594424 26.5528 1.11665C27.075 1.63887 27.3361 2.26665 27.3361 2.99998V19C27.3361 19.7333 27.075 20.3611 26.5528 20.8833C26.0305 21.4055 25.4028 21.6666 24.6694 21.6666H3.3361ZM14.0028 12.3333L3.3361 5.66665V19H24.6694V5.66665L14.0028 12.3333ZM14.0028 9.66665L24.6694 2.99998H3.3361L14.0028 9.66665ZM3.3361 5.66665V2.99998V19V5.66665Z",
    fill: "#23262F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.e966555a908837872e004a2cf715e3d1.svg";
export { ForwardRef as ReactComponent };